import dayjs from 'dayjs';
import isSameOrAfter from './node_modules/dayjs/plugin/isSameOrAfter.js';
import advancedFormat from './node_modules/dayjs/plugin/advancedFormat.js';
import duration from './node_modules/dayjs/plugin/duration.js';
import relativeTime from './node_modules/dayjs/plugin/relativeTime.js';
import localizedFormat from './node_modules/dayjs/plugin/localizedFormat.js';

dayjs.extend(relativeTime);
dayjs.extend(advancedFormat);
dayjs.extend(duration);
dayjs.extend(localizedFormat);
dayjs.extend(isSameOrAfter);
const dayTimeFormat = "D MMM YYYY [at] LT";

export { dayTimeFormat };
//# sourceMappingURL=dayjs.js.map
